import { gql } from '@apollo/client';

const GrammarElement = gql`
  fragment GrammarElement on GrammarElement {
    id
    name
    priority
    element {
      id
      visible
      en
      type
    }
  }
`;

export default {
  GrammarElement,
};
